import axios from "axios";

export const fetchAvatar = async (instance, accounts) => {
  const account = accounts[0];
  if (account) {
    let response = await instance.acquireTokenSilent({
      scopes: ["User.Read"],
      account: account,
    });
    if (response) {
      var value = await axios.get(
        `https://graph.microsoft.com/v1.0/me/photo/$value`,
        {
          headers: { Authorization: `Bearer ${response.accessToken}` },
          responseType: "arraybuffer",
        }
      );

      var encoded = btoa(String.fromCharCode(...new Uint8Array(value.data)));

      let photo =
        "data:" + value.headers["content-type"] + ";base64," + encoded;
      return photo;
    }
  }
};

export const fetchFrameTokens = async (instance, accounts) => {
  const frameScopes = window.configs.FRAME_SCOPES ?? [];
  // frameScopes.push("https://storage.azure.com/user_impersonation");

  let defaultScopes = [];
  let resourceSpecificScopes = [];
  frameScopes.forEach((x) => {
    if (x.endsWith(".default")) {
      defaultScopes.push(x);
    } else {
      resourceSpecificScopes.push(x);
    }
  });

  const account = accounts === undefined ? null : accounts[0];

  // default scope frame tokens
  if (defaultScopes.length !== 0) {
    let frameTokenRequest = {
      scopes: defaultScopes,
      account: account,
    };

    instance
      .acquireTokenSilent(frameTokenRequest)
      .then((response) => {
        console.log(
          `succesfully acquired default frame tokens silently [${defaultScopes.join(
            ", "
          )}]`
        );
      })
      .catch((e) => {
        console.log(
          e,
          `failed to acquire default frame tokens silently [${defaultScopes.join(
            ", "
          )}]`
        );

        if (window.configs.LOGIN_TYPE?.toLowerCase() === "redirect") {
          instance.acquireTokenRedirect(frameTokenRequest);
        } else if (window.configs.LOGIN_TYPE?.toLowerCase() === "popup") {
          instance.acquireTokenPopup(frameTokenRequest);
        } else {
          instance.acquireTokenRedirect(frameTokenRequest);
        }
      });
  }

  // resource specific scope frame tokens
  if (resourceSpecificScopes.length !== 0) {
    let frameTokenRequest = {
      scopes: resourceSpecificScopes,
      account: account,
    };

    instance
      .acquireTokenSilent(frameTokenRequest)
      .then((response) => {
        console.log(
          `succesfully acquired resource specific frame tokens silently [${resourceSpecificScopes.join(
            ", "
          )}]`
        );
      })
      .catch((e) => {
        console.log(
          e,
          `failed to acquire resource specific frame tokens silently [${resourceSpecificScopes.join(
            ", "
          )}]`
        );

        if (window.configs.LOGIN_TYPE?.toLowerCase() === "redirect") {
          instance.acquireTokenRedirect(frameTokenRequest);
        } else if (window.configs.LOGIN_TYPE?.toLowerCase() === "popup") {
          instance.acquireTokenPopup(frameTokenRequest);
        } else {
          instance.acquireTokenRedirect(frameTokenRequest);
        }
      });
  }
};
